export default __webpack_public_path__ + "static/media/FAPEG.24cd2cfc.png";